import { render, staticRenderFns } from "./DataTablePaperMission.vue?vue&type=template&id=563d25fa"
import script from "./DataTablePaperMission.vue?vue&type=script&lang=js"
export * from "./DataTablePaperMission.vue?vue&type=script&lang=js"
import style0 from "./DataTablePaperMission.vue?vue&type=style&index=0&id=563d25fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports